//External lib imports
import React from 'react';

//Internal lib imports
import Routes from './routes/Routes';

const App = () => {
  return <Routes />;
};

export default App;
